import { render, staticRenderFns } from "./CheckboxButtons.vue?vue&type=template&id=f8ceb172&"
import script from "./CheckboxButtons.vue?vue&type=script&lang=js&"
export * from "./CheckboxButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports